import ReactDOM from "react-dom/client";

import { AppProviders } from "./AppProviders";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<AppProviders />);
